import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Download } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function DownloadsSection({ darkMode }) {
  const [downloadInfo, setDownloadInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/download/info`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setDownloadInfo(r.data)).catch(() => {});
  }, []);

  return (
    <div className={`rounded-xl p-6 ${darkMode ? 'bg-slate-800/50 border border-slate-700' : 'bg-white border border-slate-200 shadow-sm'}`}>
      <div className="flex items-center gap-3 mb-5">
        <div className="p-2 rounded-lg bg-dp-100">
          <Download className="w-5 h-5 text-dp-600" />
        </div>
        <h2 className={`text-xl font-heading font-bold ${darkMode ? 'text-slate-100' : 'text-slate-800'}`}>Software Downloads</h2>
      </div>

      {downloadInfo ? (
        <div className="space-y-3">
          <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
            Download the DentalPulse desktop application for your operating system:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {downloadInfo.platforms?.map(platform => (
              <a
                key={platform.name}
                href={platform.url}
                className={`flex items-center gap-3 p-4 rounded-lg border transition-colors ${
                  darkMode
                    ? 'border-slate-600 bg-slate-700/50 hover:bg-slate-700 text-slate-200'
                    : 'border-slate-200 bg-white hover:bg-slate-50 text-slate-700'
                }`}
                data-testid={`download-${platform.name.toLowerCase()}`}
              >
                <Download className="w-5 h-5 text-dp-500" />
                <div>
                  <p className="font-medium text-sm">{platform.name}</p>
                  <p className={`text-xs ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{platform.description}</p>
                </div>
              </a>
            ))}
          </div>
          <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
            Version {downloadInfo.version || '1.0.0'} - Auto-updates enabled
          </p>
        </div>
      ) : (
        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
          Download information unavailable. Please ensure your subscription is active.
        </p>
      )}
    </div>
  );
}
